<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <button class="returnBtn" @click="back">返回</button>
    <div  class="mt-2 container d-flex justify-content-center flex-column align-items-center" v-if="!isLoading&&order!=undefined">        
        <div class="topTitle d-flex justify-content-center">{{order.description }}付款成功</div>
        <div  class="mt-1">
            <div class="title">订单号：{{ out_trade_id }}</div>
            <div class="mt-1 title">付款日期：{{ localDatetime(order.updatedDate) }}</div>
            <div class="mt-1 title">金额: {{order.amount }}</div>
        </div>
       <div class="mt-3 title">
        出现任何问题，请添加客服微信
       </div>
       
    </div>  
  
  </template>
  
  <script>
  
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import axios from 'axios';

  import moment from 'moment';
  
  export default {
    data(){
      
      return {
        
        isLoading:false,
       
        spinnerColor:"#262626",
        accountId:null,
        out_trade_id:null,
        order:null,
        axiosSource: axios.CancelToken.source()
      }
      
    },
    computed: {
 
    localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     },
    formatDate(){
      return (datetimeString) => {
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD');
         return beijingTime
         
       }
     }
  },


    components: {
      GridLoader,
    },
     setup(){
      
       var token=localStorage.getItem('sessionToken')
       axios.defaults.headers.common['X-Parse-Session-Token'] = token
  
    },
  

    unmounted(){
       
        this.stopCheck=true;
        console.log('unmouted...')
    },

    beforeUnmount(){
      console.log('cancel axios')
      this.stopCheck=true;
      this.axiosSource.cancel('Operation canceled by the user.'); // 在beforeDestroy钩子中使用取消令牌源取消请求
     },
  
    mounted(){
      var token=localStorage.getItem('sessionToken');
      this.role=localStorage.getItem('role');
  
       if(token==undefined || token==null ||token=='')
       {
          this.$router.push('index')
          return
       }

       this.out_trade_id = this.$route.params.id;
       this.getOrder()
      
    },
    methods:{
    
  
        back(){
      
      this.stopCheck=true;
      
        this.$router.go(-1)
      },
  
  
       async getOrder(){
        try{
           
            this.isLoading=true;
          const response = await axios.get(this.domain+'xhs/get_account_order?out_trade_id='+this.out_trade_id,{ 
                  cancelToken: this.axiosSource.token // 在axios请求中使用取消令牌
            });
  
          var data=response.data
          if(data.status=='Suc')
          {
              var order=data.order
              this.order=order;
             
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
              } 
              else
              {
                console.error(data)
              }
            
        }
        finally{
            this.isLoading=false;
        }
       
       
      },


      async checkPaid(){
        try{
            console.log('check....')
            console.log(this.stopCheck)
            if(this.stopCheck)
            {
                return
            }
          const response = await axios.get(this.domain+'xhs/queryorder?out_order_id='+this.out_trade_id+'&amount='+this.products[this.selectedProduct].price
          ,{ 
                  cancelToken: this.axiosSource.token // 在axios请求中使用取消令牌
            });
  
          var data=response.data
          const status = data['status'];
          console.log(data)
            if(status == 'SUCCESS')
            {
                return true;
            }
            else if(status=='NOTPAY'){
                this.checkPaid()
            }
         
        }
        catch(error)
        {
            if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
              } 
              else
              {
                console.error(data)
              }
            
        }
      
       
       
      },

      
      async getQr(){
        try{
            
            this.stopCheck=true;
            this.isLoading=true;
            
           var selected_product= this.products[this.selectedProduct]
           var parse_data={
            'product_id':selected_product.objectId,
            'amount':selected_product.price,
            'description':selected_product.name,
            
            cancelToken: this.axiosSource.token
            
           }
          const response = await axios.post(this.domain+'xhs/wechatpay',parse_data);
  
          var data=response.data
          if(data.status=='Suc')
          {
              this.qr_url=data.code_url
              this.out_trade_id=data.out_trade_no
              this.stopCheck=false;

            console.log('checking flag')
              console.log(this.stopCheck)
             this.checkPaid()
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
              } 
              else
              {
                console.error(data)
              }
        }
        finally{
            this.isLoading=false;
        }
       
       
      },
  
    }
     
    
  };
  </script>
  <style scoped>
  .bg{
    background-color:#F9F9F9;
    border: 0;
  }
  .selectedBox{
    background-color: #f18f14;
    color:#4a2e2a;
  }
  
  .title{
    color:#666666;
    font-weight: 800;
    font-size: 0.25rem;
  }
  .selectedTitle{
    color:#4a2e2a;
    font-weight: 800;
    font-size: 0.25rem;
  }
  .price{
    font-size: 0.7rem;
    font-weight: 700;
  }
  .unit{
    font-size: 0.4rem;
    font-weight: 500;
  }
  
  .error-message{
    color:red
  }
  </style>
  
  
  